import { render, staticRenderFns } from "./EditShortcutGroupV2.vue?vue&type=template&id=5ae189b2&scoped=true"
import script from "./EditShortcutGroupV2.vue?vue&type=script&lang=js"
export * from "./EditShortcutGroupV2.vue?vue&type=script&lang=js"
import style0 from "./EditShortcutGroupV2.vue?vue&type=style&index=0&id=5ae189b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae189b2",
  null
  
)

export default component.exports